import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1769aa',
            dark: '#0f4f86',
            light: '#e8f2fb',
        },
        background: {
            default: '#f5f7fa',
            paper: '#ffffff',
        },
        text: {
            primary: '#172033',
            secondary: '#5f6b7a',
        },
        divider: '#e3e8ef',
    },
    shape: {
        borderRadius: 12,
    },
    spacing: 8,
    typography: {
        fontFamily: '"Roboto", "Segoe UI", sans-serif',
        h4: {
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.25,
            letterSpacing: '-0.015em',
        },
        h6: {
            fontWeight: 600,
            lineHeight: 1.35,
        },
        body1: {
            lineHeight: 1.6,
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    minHeight: 36,
                    paddingInline: 14,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    border: '1px solid #e3e8ef',
                    boxShadow: '0 2px 10px rgba(15, 23, 42, 0.06)',
                    borderRadius: 14,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 14,
                },
                elevation3: {
                    border: '1px solid #e3e8ef',
                    boxShadow: '0 3px 14px rgba(15, 23, 42, 0.07)',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f3f6f9',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: '#334155',
                    fontWeight: 600,
                    borderBottom: '1px solid #dbe2ea',
                },
                body: {
                    borderBottom: '1px solid #edf0f4',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    marginInline: 8,
                    marginBlock: 2,
                    width: 'calc(100% - 16px)',
                    '&:hover': {
                        backgroundColor: '#eaf2fa',
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#e1eef9',
                        color: '#0f4f86',
                        '& .MuiListItemIcon-root': { color: '#1769aa' },
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:last-child td': { borderBottom: 0 },
                    '&:hover': { backgroundColor: '#f8fafc' },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                },
            },
        },
    },
});

export default theme;
